import { h } from 'preact';
import store from '../store';
import { Route, Router } from 'preact-router';

import Header from './header';

// Code-splitting is automated for `routes` directory
import Home from '../routes/home';
import Profile from '../routes/profile';
import CC_Screen from '../routes/cc-screen';
import { Provider, useDispatch } from 'react-redux';
import { initApp } from '../action';
import { useEffect, useState } from 'preact/hooks';
import User_Not_Found from '../routes/user-not-found';


export const fetchLanguage = async (url) => {
	try {
	  const language = new URL(url).searchParams.get('language');
	  if (language !== null && language.trim() !== '' && language.length !== 0) {
		  return language;
		} else {
			return 'eng';
		}
	} catch (error) {
	  console.error(error);
	}
  };

const App = () => {
	const [language, setLanguage] = useState('');
	useEffect(() => {
	  const currentUrl = window.location.href;
	  const fetchData = async () => {
		const fetchedLanguage = await fetchLanguage(currentUrl);
		setLanguage(fetchedLanguage);
	  };
	  fetchData();
	}, []);
	return(
		<div id="app">
			<main>
				<Provider store={store}>
				<Router>
					<Route path='/' exact component={CC_Screen}  language={language} />
					<Route path='/cc-screen' exact component={CC_Screen}  language={language} />
					<Route path='/not-found' exact component={User_Not_Found} language={language} />
				</Router>
				</Provider>
			</main>
		</div>
	)
};

export default App;
